<template>
    <v-dialog
            width="1200"
            :value="showExtrasDialog"
            @input="closeDialog()"
    >
        <v-card>
            <v-card-text>
                <v-tabs
                        v-model="active"
                >
                    <v-tab v-if="car.special_extras" :key="car.special_extras ? 1 : 2">
                        Alapfelszereltségétől eltérő felszereltség
                    </v-tab>
                    <v-tab :key="car.special_extras ? 2 : 1">
                        Teljes felszereltség
                    </v-tab>
                    <v-tab-item :key="1" v-if="car.special_extras">
                        <div class="scrollable">
                            <div v-if="car.special_extras.length === 0">
                                Nincs megjelenítendő elem.
                            </div>

                            <ul>
                                <li
                                        v-for="extra in car.special_extras"
                                        :key="extra.eq_code"
                                        style="margin-bottom: 10px;"
                                >
                                    {{ extra.name }}
                                </li>
                            </ul>
                        </div>
                    </v-tab-item>
                    <v-tab-item :key="2">
                        <div class="scrollable">
                            <ul>
                                <li
                                        v-for="extra in car.extras"
                                        :key="extra.eq_code"
                                        style="margin-bottom: 10px;"
                                >
                                    {{ extra.name }}
                                </li>
                            </ul>
                        </div>
                    </v-tab-item>
                </v-tabs>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="primaryButtonColor"
                    style="color: var(--v-primaryButtonTextColor-base);"
                    @click="closeDialog()"
                >
                    Bezárás
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
export default {
    name: 'ExtrasDialog',
    props: {
        car: {},
        showExtrasDialog: {},
    },
    data() {
        return {
            active: null,
        };
    },
    methods: {
        closeDialog() {
            this.$emit('close-dialog');
        },
    },
};
</script>

<style scoped>
    .scrollable {
        max-height: 350px;
        overflow-y: scroll;
    }

    ul {
        list-style-type: none;
        padding: 35px;
        max-width: 68%;
        margin-left: auto;
        margin-right: auto;
    }

    li {
        padding: 10px;
        box-shadow: 0 0 2px gray;
    }
</style>
